import { ProgressSpinner } from "primereact/progressspinner";
import React from "react";

interface PageLoaderProps {
    containerClassName?: string;
    color?: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({ containerClassName, color }) => {
    return (
        <div className={`loading_container page_loader ${containerClassName ? containerClassName : ''}`}>
            <ProgressSpinner
                className="progresscircle custom"
                style={{ width: '50px', height: '50px', stroke: color ? color : '#8953D7' }}
                strokeWidth="8"
                fill="#FFF"
                animationDuration="1s"
            />
        </div>
    )
}

export default PageLoader;